/* eslint-disable no-cyrillic-string/no-cyrillic-string */
export default {
    title: 'Ваши данные для оплаты',
    chooseTitle: 'Выберите другой аккаунт',
    selectOtherAcc: 'Выбрать другой аккаунт',
    changeBtn: 'Изменить',
    payBtn: 'Далее'
};
